import { useEffect } from 'react';
import { useSubscription } from '../hooks/useSubscription';
import BillingSalesContent from './billing/BillingSalesContent';

/**
 * Trial billing v2: when access is expired, block the entire app with the billing
 * sales page as a non-dismissible full-screen overlay.
 */
export default function TrialExpiredGate() {
  const { entitlements, loading, isTrialExpiredGateEnabled } = useSubscription();

  const isExpired =
    isTrialExpiredGateEnabled && !loading && entitlements.access === 'expired' && entitlements.billingHold !== 'paused';

  useEffect(() => {
    if (!isExpired) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isExpired]);

  if (!isExpired) return null;

  return (
    <div
      className="fixed inset-0 z-[9998] overflow-y-auto bg-bone"
      role="dialog"
      aria-modal="true"
      aria-label="Trial expired"
      data-testid="trial-expired-gate"
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <BillingSalesContent mode="expired_overlay" />
    </div>
  );
}
